var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBespoke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 20,
    fill: "#22A0DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.43 15.355h-9.556v-2.722c0-.902.73-1.633 1.633-1.633h6.29c.902 0 1.633.731 1.633 1.633v2.722z",
    fill: "url(#bespoke_svg__paint0_linear_1242_149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.975 15.355h-9.557v-2.722c0-.902.731-1.633 1.633-1.633h6.29c.902 0 1.634.731 1.634 1.633v2.722z",
    fill: "url(#bespoke_svg__paint1_linear_1242_149)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.374 14.1v-1.467c0-.902-.731-1.633-1.633-1.633h-6.29c-.902 0-1.634.731-1.634 1.633v17.634a2.327 2.327 0 002.327 2.326h17.822a2.327 2.327 0 002.327-2.326v-13.13a2.327 2.327 0 00-2.327-2.326h-9.881a.71.71 0 01-.71-.711z",
    fill: "url(#bespoke_svg__paint2_linear_1242_149)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.572 18.011h-.56a.582.582 0 01-.582-.582v-.56c0-.321.26-.582.582-.582h.56c.322 0 .582.26.582.582v.56c0 .322-.26.582-.582.582z",
    fill: "url(#bespoke_svg__paint3_linear_1242_149)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.77 18.011h-.56a.582.582 0 01-.583-.582v-.56c0-.321.261-.582.582-.582h.56c.322 0 .583.26.583.582v.56c0 .322-.261.582-.582.582z",
    fill: "url(#bespoke_svg__paint4_linear_1242_149)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.968 18.011h-.56a.582.582 0 01-.582-.582v-.56c0-.321.26-.582.581-.582h.56c.322 0 .583.26.583.582v.56c0 .322-.26.582-.582.582z",
    fill: "url(#bespoke_svg__paint5_linear_1242_149)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.966 32.593a2.327 2.327 0 002.326-2.326v-8.473l-2.984-2.985a2.32 2.32 0 00-1.751-.795h-2.729l-3.17-3.204H15.818v15.432a2.351 2.351 0 002.351 2.351h17.798z",
    fill: "url(#bespoke_svg__paint6_linear_1242_149)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.817 27.694v2.573a2.327 2.327 0 002.326 2.327h17.823a2.327 2.327 0 002.326-2.327v-2.573H15.817z",
    fill: "url(#bespoke_svg__paint7_linear_1242_149)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.023 18.558h-9.557v-2.722c0-.902.731-1.633 1.633-1.633h6.29c.902 0 1.634.731 1.634 1.633v2.722z",
    fill: "url(#bespoke_svg__paint8_linear_1242_149)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.567 18.558H16.01v-2.722c0-.902.731-1.633 1.633-1.633h6.29c.903 0 1.634.731 1.634 1.633v2.722z",
    fill: "url(#bespoke_svg__paint9_linear_1242_149)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.965 17.303v-1.467c0-.902-.73-1.633-1.633-1.633h-6.29c-.902 0-1.633.731-1.633 1.633V33.47a2.327 2.327 0 002.326 2.327h17.822a2.327 2.327 0 002.327-2.327V20.34a2.327 2.327 0 00-2.327-2.326h-9.88a.71.71 0 01-.712-.711z",
    fill: "url(#bespoke_svg__paint10_linear_1242_149)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.165 21.214h-.56a.582.582 0 01-.582-.582v-.56c0-.321.26-.582.581-.582h.56c.322 0 .582.26.582.582v.56c0 .322-.26.582-.581.582z",
    fill: "url(#bespoke_svg__paint11_linear_1242_149)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.363 21.214h-.56a.582.582 0 01-.582-.582v-.56c0-.321.26-.582.582-.582h.56c.322 0 .582.26.582.582v.56c0 .322-.26.582-.582.582z",
    fill: "url(#bespoke_svg__paint12_linear_1242_149)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.562 21.214h-.56a.582.582 0 01-.583-.582v-.56c0-.321.26-.582.582-.582h.56c.322 0 .583.26.583.582v.56c0 .322-.261.582-.582.582z",
    fill: "url(#bespoke_svg__paint13_linear_1242_149)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.558 35.796a2.327 2.327 0 002.327-2.326v-8.473L32.9 22.012a2.32 2.32 0 00-1.75-.795h-2.73l-3.17-3.203H13.41v15.431a2.351 2.351 0 002.351 2.351h17.798z",
    fill: "url(#bespoke_svg__paint14_linear_1242_149)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.41 30.898v2.572a2.327 2.327 0 002.326 2.327h17.822a2.327 2.327 0 002.327-2.327v-2.572H13.409z",
    fill: "url(#bespoke_svg__paint15_linear_1242_149)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.613 21.761h-9.556V19.04c0-.902.73-1.633 1.633-1.633h6.29c.902 0 1.633.731 1.633 1.633v2.722z",
    fill: "url(#bespoke_svg__paint16_linear_1242_149)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.158 21.761H13.6V19.04c0-.902.731-1.633 1.633-1.633h6.29c.903 0 1.634.731 1.634 1.633v2.722z",
    fill: "url(#bespoke_svg__paint17_linear_1242_149)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.557 20.506V19.04c0-.902-.731-1.633-1.633-1.633h-6.29c-.903 0-1.634.731-1.634 1.633v17.634A2.327 2.327 0 0013.327 39h17.822a2.327 2.327 0 002.326-2.327v-13.13a2.327 2.327 0 00-2.326-2.326h-9.882a.71.71 0 01-.71-.71z",
    fill: "url(#bespoke_svg__paint18_linear_1242_149)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.756 24.417h-.56a.582.582 0 01-.583-.582v-.56c0-.321.26-.582.582-.582h.56c.322 0 .582.26.582.582v.56c0 .322-.26.582-.581.582z",
    fill: "url(#bespoke_svg__paint19_linear_1242_149)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.954 24.417h-.56a.582.582 0 01-.582-.582v-.56c0-.321.26-.582.581-.582h.56c.322 0 .583.26.583.582v.56c0 .322-.261.582-.582.582z",
    fill: "url(#bespoke_svg__paint20_linear_1242_149)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.151 24.417h-.56a.582.582 0 01-.582-.582v-.56c0-.321.26-.582.582-.582h.56c.322 0 .582.26.582.582v.56c0 .322-.26.582-.582.582z",
    fill: "url(#bespoke_svg__paint21_linear_1242_149)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11 34.1v2.573A2.327 2.327 0 0013.327 39h17.822a2.327 2.327 0 002.326-2.327v-2.572H11z",
    fill: "url(#bespoke_svg__paint22_linear_1242_149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint0_linear_1242_149",
    x1: 25.652,
    y1: 11.907,
    x2: 25.652,
    y2: 15.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint1_linear_1242_149",
    x1: 23.196,
    y1: 11.907,
    x2: 23.196,
    y2: 15.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90CC1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint2_linear_1242_149",
    x1: 23.336,
    y1: 12.118,
    x2: 33.4,
    y2: 43.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint3_linear_1242_149",
    x1: 31.101,
    y1: 17.003,
    x2: 31.888,
    y2: 17.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint4_linear_1242_149",
    x1: 33.298,
    y1: 17.003,
    x2: 34.086,
    y2: 17.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint5_linear_1242_149",
    x1: 35.496,
    y1: 17.003,
    x2: 36.284,
    y2: 17.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint6_linear_1242_149",
    x1: 26.68,
    y1: 23.724,
    x2: 35.092,
    y2: 2.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B799D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#096380",
    stopOpacity: 0.365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#084F67",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint7_linear_1242_149",
    x1: 27.055,
    y1: 29.751,
    x2: 27.055,
    y2: 34.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B799D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364,
    stopColor: "#096380",
    stopOpacity: 0.365
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#084F67",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07485E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint8_linear_1242_149",
    x1: 23.244,
    y1: 15.11,
    x2: 23.244,
    y2: 18.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0095FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint9_linear_1242_149",
    x1: 20.789,
    y1: 15.11,
    x2: 20.789,
    y2: 18.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48B2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0095FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint10_linear_1242_149",
    x1: 14.987,
    y1: 17.246,
    x2: 29.421,
    y2: 31.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint11_linear_1242_149",
    x1: 28.693,
    y1: 20.206,
    x2: 29.481,
    y2: 20.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint12_linear_1242_149",
    x1: 30.892,
    y1: 20.206,
    x2: 31.679,
    y2: 20.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint13_linear_1242_149",
    x1: 33.09,
    y1: 20.206,
    x2: 33.878,
    y2: 20.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint14_linear_1242_149",
    x1: 24.381,
    y1: 36.02,
    x2: 24.852,
    y2: 17.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint15_linear_1242_149",
    x1: 24.647,
    y1: 32.954,
    x2: 24.647,
    y2: 37.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint16_linear_1242_149",
    x1: 20.835,
    y1: 18.314,
    x2: 20.835,
    y2: 21.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint17_linear_1242_149",
    x1: 18.379,
    y1: 18.314,
    x2: 18.379,
    y2: 21.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint18_linear_1242_149",
    x1: 12.579,
    y1: 20.449,
    x2: 27.012,
    y2: 34.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint19_linear_1242_149",
    x1: 26.284,
    y1: 23.409,
    x2: 27.072,
    y2: 24.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint20_linear_1242_149",
    x1: 28.482,
    y1: 23.409,
    x2: 29.27,
    y2: 24.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint21_linear_1242_149",
    x1: 30.68,
    y1: 23.409,
    x2: 31.468,
    y2: 24.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bespoke_svg__paint22_linear_1242_149",
    x1: 22.238,
    y1: 36.157,
    x2: 22.238,
    y2: 40.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })))));
}
export default "/_next/static/media/bespoke.ef99c89ef5e5a2a4fd9c2d6d87aaa91a.svg";
export { SvgBespoke as ReactComponent };